module.exports = __webpack_public_path__ + "img/img-eat-05.01526836.png";